"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = exports.fontTokens = void 0;
/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var fontTokens = {
  primaryFontFamily: 'UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
exports.fontTokens = fontTokens;
var secondaryFontFamily = 'UberMove, UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif';
var typography = {
  font1450: {
    fontFamily: secondaryFontFamily
  },
  font1350: {
    fontFamily: secondaryFontFamily
  },
  font1250: {
    fontFamily: secondaryFontFamily
  },
  font1150: {
    fontFamily: secondaryFontFamily
  },
  DisplayLarge: {
    fontFamily: secondaryFontFamily
  },
  DisplayMedium: {
    fontFamily: secondaryFontFamily
  },
  DisplaySmall: {
    fontFamily: secondaryFontFamily
  },
  DisplayXSmall: {
    fontFamily: secondaryFontFamily
  }
};
exports.typography = typography;